// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XEmo","image":"Header_image__1c8uM","name":"Header_name__4Fu6R","info":"Header_info__ch4lM","infoRow":"Header_infoRow__xl8RZ"};